import { render, staticRenderFns } from "./StockEdit.vue?vue&type=template&id=500adbbd&scoped=true"
import script from "./StockEdit.vue?vue&type=script&lang=ts"
export * from "./StockEdit.vue?vue&type=script&lang=ts"
import style0 from "./StockEdit.vue?vue&type=style&index=0&id=500adbbd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500adbbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500adbbd')) {
      api.createRecord('500adbbd', component.options)
    } else {
      api.reload('500adbbd', component.options)
    }
    module.hot.accept("./StockEdit.vue?vue&type=template&id=500adbbd&scoped=true", function () {
      api.rerender('500adbbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stock/StockEdit.vue"
export default component.exports